import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import Button from 'modules/_shared/components/Buttons';

import { useNotesSection } from '../context/NotesSectionContext';

const NotesSectionHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useNotesSection();

  const isButtonDisabled = !data.isAdmin || data.isReadOnly;

  return (
    <div className="nk-block-between d-flex flex-column flex-md-row">
      <div className="nk-block-head-content">
        <h4 className="nk-block-title">{t('Annotations')}</h4>
        <div className="nk-block-des">
          <p>{t('AnnotationTabDescription')}</p>
        </div>
      </div>

      <div className="nk-block-head-content">
        <div className="nk-block float-right">
          <Button onClick={actions.handleAddNote} disabled={isButtonDisabled}>
            <em className="icon ni ni-plus" />
            <span>{t('AddAnnotation')}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotesSectionHeader;
